<template>
  <div>
    <div
      v-if="clickLogin"
      class="mx-auto relative"
      :class="
        props.type == 'simplify' ? 'w-200 h-200 mb-34' : 'w-242 h-242 mb-42'
      "
    >
      <div
        class="flex flex-col justify-center items-center cursor-pointer"
        style="margin-top: 60px"
        @click="handleClick"
      >
        <img src="@/assets/img/icon-wx.png" class="w-74 h-74 mb-23" />
        <div
          class="w-192 h-44 flex items-center justify-center color-#fff fw-600 bg-#39B54A borderRadius-8"
          >使用微信扫码登录
        </div>
      </div>
      <div style="text-align: center; margin-top: 30px">
        <el-button type="primary" link @click="RegisterAnAccount">
          注册账号
        </el-button>
      </div>
    </div>
    <div
      v-else
      v-loading="loading"
      class="mx-auto relative"
      :class="
        props.type == 'simplify' ? 'w-200 h-200 mb-34' : 'w-242 h-242 mb-42'
      "
    >
      <img
        v-if="qrCodeUrl"
        :src="qrCodeUrl"
        @load="loading = false"
        style="margin-top: 20px"
        :class="props.type == 'simplify' ? 'w-200 h-200' : 'w-242 h-242'"
      />
      <div
        v-if="refreshStatus"
        class="absolute top-5 left-0 w-100% h-100% bg-#00000099 flex justify-center items-center"
      >
        <!-- 刷新 -->
        <!-- <div class="w-130 h-100 bg-#ffffff flex justify-center items-center"> -->
        <el-button type="info" class="h-80 fs-16" @click="getQrCode">
          二维码已失效，刷新
        </el-button>
        <!-- </div> -->
      </div>
    </div>
    <div v-if="qrCodeUrl">
      <div class="maers">微信扫码登录</div>
      <div class="maeyi">请使用微信扫描二维码登录或注册</div>
    </div>
  </div>
</template>

<script setup>
import { getLoginQrCode, checkLoginQrCodeState } from '@/api/home'
import { useUserStore } from '@/store/modules/user'

const emit = defineEmits(['changeLoginType'])
const userStore = useUserStore()
const props = defineProps({
  type: {
    type: String,
    default: 'complex', // simplify 精简版 complex 复杂版
  },
})
const clickLogin = ref(true) // 点击登录
const qrCodeUrl = ref('') // 二维码地址
const timer = ref(null) // 定时器
const refreshStatus = ref(false) // 刷新状态
const loading = ref(false)
const sceneId = ref(null)

onUnmounted(() => {
  clearInterval(timer.value)
})

function RegisterAnAccount() {
  if (userStore.getShowLoginStatus) {
    emit('changeLoginType', 'register')
  } else {
    userStore.setShowLogin(true, 'register')
  }
}

function handleClick() {
  clickLogin.value = false
  getQrCode()
}

function getQrCode() {
  loading.value = true
  getLoginQrCode().then(res => {
    qrCodeUrl.value = res.data.mpTmpQrCode
    sceneId.value = res.data.sceneId
    refreshStatus.value = false
    timer.value = setInterval(() => {
      startCheck()
    }, 3000)
    setTimeout(() => {
      refreshStatus.value = true
      clearInterval(timer.value)
    }, 30000)
  })
}

// 检查扫码状态
function startCheck() {
  checkLoginQrCodeState(sceneId.value).then(res => {
    console.log(res)
    if (res.data.isBindMobile == false) {
      // 未绑定手机号
      console.log('进来了111')
      localStorage.setItem('openId', res.data.openId)
      emit('changeLoginType', 'bindMobile', res.data.userId)
    } else {
      // 已绑定手机号
      console.log('进来了22222')
      // clearInterval(timer.value)
      if (res.data.token) {
        userStore.setToken(res.data.token)
        userStore.setShowLogin(false)
      } else if (res.data.isSetPassword == false) {
        console.log('未设置密码')
        // 绑定手机号，但未设置密码
        localStorage.setItem('openId', res.data.openId)
        emit('changeLoginType', 'bindMobile', res.data.userId, res.data.mobile)
      }
    }
  })
}
</script>

<style scoped lang="scss">
.maers {
  font-family: PingFangSC-semibold;
  color: #000000;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
}

.maeyi {
  font-family: PingFangSC-regular;
  color: #747474;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
}

.title {
  color: rgba(51, 51, 51, 1);
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
}

.changeLoginTT {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.login-tabs {
  display: flex;
  align-items: stretch;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  background: #fff;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  cursor: pointer;
  background: #fff;
  border: none;
  min-width: 90px;
  transition: all 0.3s ease;
  position: relative;

  &:not(:last-child) {
    border-right: 1px solid #e0e0e0;
  }

  &:first-child {
    background: #fff;
    color: #1976d2;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 2px;
      background: #1976d2;
    }
  }

  &:hover:not(:first-child) {
    background: #f5f5f5;
  }

  .tab-icon {
    width: 18px;
    height: 18px;
    margin-bottom: 4px;
    opacity: 0.7;
  }

  &:first-child .tab-icon {
    opacity: 1;
  }

  span {
    font-size: 12px;
    color: #666;
    font-weight: 400;
    line-height: 1.2;
  }

  &:first-child span {
    color: #1976d2;
    font-weight: 500;
  }
}
</style>
